// #ux-redesign-start: InboxMenu — copia del de Doctors limitada a system folders.
// Doctors tiene Folders custom + Papelera (con stats). Patients sólo expone los
// 3 system folders (Inbox / Sent / Important) porque MessagesPatientsController
// no declara las rutas /folders/* ni /restore/* ni /move-to-folder en
// routes/patients.js. El layout y el styling son idénticos al de Doctors para
// que el inbox se sienta "el mismo módulo".
//
// Si en algún momento se agregan los endpoints en MS-Messages para patients,
// restaurar el bloque de folders custom + Trash (ver Doctors/InboxMenu).
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-translate';
import {
  actionSetBox,
  actionSetMessage,
  actionGetMessages,
  actionOutboxGetMessages,
  actionGetPriorityMessages,
} from 'store/actions/messagesActions';

const SYSTEM_FOLDERS = [
  { key: 'inbox',    icon: 'icon-allmail', i18nKey: 'menu-inbox',     reducerKey: 'inbox' },
  { key: 'outbox',   icon: 'icon-send',    i18nKey: 'menu-send',      reducerKey: 'outbox' },
  { key: 'priority', icon: 'icon-star',    i18nKey: 'menu-important', reducerKey: 'prioritybox' },
];

const InboxMenu = ({ setShowForm, onFolderSelected }) => {
  const t = useTranslate('messages');
  const dispatch = useDispatch();
  const messagesState = useSelector((state) => state.messagesReducer);
  const { box } = messagesState;

  const handleSelect = (folderKey) => (e) => {
    e.preventDefault();
    dispatch(actionSetBox(folderKey));
    dispatch(actionSetMessage());
    if (setShowForm) setShowForm(false);
    if (folderKey === 'inbox') {
      dispatch(actionGetMessages());
    } else if (folderKey === 'outbox') {
      dispatch(actionOutboxGetMessages());
    } else if (folderKey === 'priority') {
      dispatch(actionGetPriorityMessages());
    }
    if (onFolderSelected) onFolderSelected();
  };

  const renderSystemItem = (folder) => {
    const total = messagesState[folder.reducerKey]?.total || 0;
    const isActive = box === folder.key;
    return (
      <ListGroupItem
        key={folder.key}
        tag="a"
        href={`#${folder.key}`}
        className={`${isActive ? 'active' : ''}`}
        onClick={handleSelect(folder.key)}
      >
        <i className={folder.icon} aria-hidden="true" />
        <span className="inbox-menu-text">
          <span>{t(folder.i18nKey)}</span>
          <span className="inbox-menu-count">({total})</span>
        </span>
      </ListGroupItem>
    );
  };

  return (
    <ListGroup className="inbox-menu" flush>
      {SYSTEM_FOLDERS.map(renderSystemItem)}
    </ListGroup>
  );
};

export default InboxMenu;
// #ux-redesign-end
